// extracted by mini-css-extract-plugin
export var details = "_lg-0";
export var inspectorPopover = "_lg-1";